const ENV = require('../_env');
const g = window[ENV.projectName] = window[ENV.projectName] || {};

// import OnScreenItem from './onScreenItem/OnScreenItem';

export default class Contents {
  constructor() {
    // html, body
    this.body = document.body;
    this.html = this.body.parentElement;

    this._scrollToTweenObj = { value: 0 };
    this._onScreenItems = [];

    this._mobileResizeHanndler = this._mobileResizeHanndler.bind(this);
    this._resizeHandler = this._resizeHandler.bind(this);
    this._scrollHandler = this._scrollHandler.bind(this);
    this._cancelScrollToAnimation = this._cancelScrollToAnimation.bind(this);
  }

  async _init() {
    this._initVuexStore();
    this._initMediaQuery();
    this._initScroll();

    await Promise.all([
      this._loadFonts(),
      this._initContents()
    ]);

    this._initResize();

    await this._removeGlobalLoading();

    this._scrollHandler(null, true);
  }

  async _initContents() {
    return true;
  }

  // remove global loading
  async _removeGlobalLoading() {
    this._globalLoading = this.body.querySelector('.js-globalLoading');

    return new Promise((resolve) => {
      var transitionEndHandler;
      this._globalLoading.classList.remove('is-noAnim');
      transitionEndHandler = (e) => {
        if (e.target.classList.contains('is-loaded')) {
          this._globalLoading.removeEventListener('transitionend', transitionEndHandler);
          if(this._globalLoading.parentElement) this._globalLoading.parentElement.removeChild(this._globalLoading);
          this.store.commit('setIsLoaded', true);
          resolve();
        }
      };
      this._globalLoading.classList.add('is-loaded');
      this.html.classList.add('is-loaded');
      this._globalLoading.addEventListener('transitionend', transitionEndHandler, { passive: true });
    });
  }

  // load fonts
  async _loadFonts() {
    return new Promise((resolve, reject)=> {
      console.log('loading fonts...');
      WebFont.load({
        google: { families: [ 'Noto Sans JP:500,700', 'Heebo:500' ] },
        timeout: 3000,
        fontactive: ()=> { console.log('fontactive', arguments); },
        active: ()=> {
          console.log('all fonts loaded');
          resolve();
        },
        inactive: ()=> {
          console.error('font inactive');
          resolve('load fonts error');
        }
      });
    });
  }

  // init vuex store
  _initVuexStore() {
    const self = this;

    return this.store = new Vuex.Store({
      state: {
        scrollTop: window.scrollY || window.pageYOffset,
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
        layoutMode: 's',
        isLoaded: false,
        isAnother: false,
        isVideoOpened: false,
        isAnimating: true,
        isInited: false
      },
      mutations: {
        setScrollTop(state) {
          state.scrollTop = window.scrollY || window.pageYOffset;
        },
        setLayoutMode(state, layoutMode) { state.layoutMode = layoutMode; },
        setWindowSize(state) {
          state.windowWidth = window.innerWidth;
          state.windowHeight = window.innerHeight;
        },
        setIsLoaded(state, isLoaded) { state.isLoaded = isLoaded },
        setIsAnother(state, isAnother) { state.isAnother = isAnother },
        setIsVideoOpened(state, isVideoOpened) { state.isVideoOpened = isVideoOpened },
        setIsAnimating(state, isAnimating) { state.isAnimating = isAnimating },
        setIsInited(state, isInited) { state.isInited = isInited }
      }
    });
  }

  // async _initOnScreenItems(els, autoPlay = true, triggerEl = null, OnScreenItemClass = OnScreenItem, onScreen = null, isAnother = false) {
  //   if(!els || els.length == 0) return;
  //   const promises = [];
  //   const items = [];
  //   for (let i = 0, l = els.length; i < l; i++) {
  //     promises.push(
  //       this._initOnScreenItem(els[i], autoPlay, triggerEl, OnScreenItemClass, onScreen, isAnother)
  //       .then((item)=> { items.push(item); })
  //     );
  //   }
  //   return Promise.all(promises)
  //   .then(()=> { return items; })
  // }

  // async _initOnScreenItem(el, autoPlay = true, triggerEl = null, OnScreenItemClass = OnScreenItem, onScreen = null, isAnother = false) {
  //   return new Promise((resolve)=> {
  //     const opt = {
  //       el,
  //       store: this.store,
  //       data: {
  //         autoPlay,
  //         triggerEl,
  //         isAnother
  //       },
  //       mounted() { resolve(this); }
  //     };
  //     if(onScreen) {
  //       opt.methods = { onScreen };
  //     }
  //     const item = new OnScreenItemClass(opt);
  //     this._onScreenItems.push(item);
  //   });
  // }

  // scroll to
  async _scrollTo(posTo, duration = 1, delay = 0, ease = Expo.easeInOut, onStart = null, onEnd = null) {
    const scrollHeight = (this.body.scrollHeight || this.html.scrollHeight) - window.innerHeight;
    posTo = Math.min(posTo, scrollHeight);

    this._killScrollTween();

    return new Promise((resolve) => {
      const posFrom = window.scrollY || window.pageYOffset;

      if (posTo === posFrom) return resolve();

      this._scrollToTweenObj = { value: posFrom };

      TweenMax.to(this._scrollToTweenObj, duration, {
        value: posTo,
        overwrite: true,
        ease,
        delay,
        onStart: () => {
          if (onStart != null) onStart();
        },
        onUpdate: () => {
          window.scrollTo(0, this._scrollToTweenObj.value);
        },
        onComplete: () => {
          if (onEnd != null) onEnd();
          return resolve();
        }
      });
    });
  }

  _killScrollTween() {
    if(this._scrollToTweenObj) TweenMax.killTweensOf(this._scrollToTweenObj);
    this._scrollToTweenObj = null;
  }

  // init scroll
  _initScroll() {
    this._scrollCount = 0;
    window.addEventListener('scroll', this._scrollHandler, { passive: false });
    window.addEventListener('wheel', this._cancelScrollToAnimation, { passive: false });
    window.addEventListener('touchmove', this._cancelScrollToAnimation, { passive: false });
  }

  _cancelScrollToAnimation(e = null) {
    this._killScrollTween();
  }

  _scrollHandler(e = null, force = false) {
    if(!force && ++this._scrollCount % 2 !== 0) return;
    this.store.commit('setScrollTop');
    for(let i = 0, l = this._onScreenItems.length; i < l; i++) {
      this._onScreenItems[i].onScroll();
    }
    this._onScrollContents();
  }

  _initMediaQuery() {
    this._mq = window.matchMedia("(min-width:768px)");
    this._mediaQueryHandler(null, true);
  }

  // change break point
  _mediaQueryHandler(e = null, checkOnly = false) {
    if (this._mq.matches) {
      // L
      this.store.commit('setLayoutMode', 'l');
    } else {
      // S
      this.store.commit('setLayoutMode', 's');
    }

    if(!checkOnly) this._onMediaQueryContents();
  }

  // init resize action
  _initResize() {
    if (g.md.mobile()) {
      this._resizeTimer = null;
      // window.addEventListener 'resize', @_mobileResizeHanndler
      window.addEventListener('orientationchange', this._mobileResizeHanndler, { passive: true });
    } else {
      window.addEventListener('resize', this._resizeHandler, { passive: true });
    }
    this._resizeHandler();
  }

  _mobileResizeHanndler(e = null) {
    if (this._resizeTimer != null) {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = null;
    }
    this._resizeTimer = setTimeout((() => {
      this._resizeHandler();
    }), 300);
  }

  _resizeHandler(e = null, toScroll = true) {
    this.store.commit('setWindowSize');
    // for(let i = 0, l = this._onScreenItems.length; i < l; i++) {
    //   this._onScreenItems[i].onResize();
    // }
    this._mediaQueryHandler();
    this._resizeContents();
    if(toScroll) this._scrollHandler(null, true);
  }

  _resizeContents() {
  }

  _onMediaQueryContents() {
  }

  _onScrollContents() {
  }
};
